import ApiService from "./api.service";

export default {
  getLicenciadasPorConta(conta_id, opcoes = { showOverlay: true }) {
    return ApiService.get(
      "/administrativo/sql-runner/sis-licenciada",
      conta_id,
      opcoes["showOverlay"]
    );
  },
  getModeloPorSisLicenciada(
    sistema_licenciada_id,
    opcoes = { showOverlay: true }
  ) {
    return ApiService.get(
      "/administrativo/sql-runner/modelo",
      sistema_licenciada_id,
      opcoes["showOverlay"]
    );
  },
  execQuery(
    sistema_licenciada_id,
    payload,
    opcoes = { showOverlay: true },
    dadosModelo = {}
  ) {
    return ApiService.post(
      "/administrativo/sql-runner/exec-query",
      { sistema_licenciada_id, payload, ...dadosModelo },
      null,
      opcoes["showOverlay"]
    );
  },
  respostaQuery(sistema_licenciada_id, uid, opcoes = { showOverlay: true }) {
    return ApiService.get(
      "/administrativo/sql-runner/exec-query/resposta",
      `${sistema_licenciada_id}/${uid}`,
      opcoes["showOverlay"]
    );
  }
};
